import { useQuery } from '@tanstack/react-query';
import {
  countUploadedCSV,
  getCSVMetrics,
  getUploadedCSV,
} from 'services/metrics';

const CSV_INFO_REFRESH_INTERVAL = 1000 * 30; // 30seconds
const CSV_INFO_REFRESH_INTERVAL_LONG = 1000 * 60 * 5; // 5mins
const CSV_METRICS_REFRESH_INTERVAL = 1000 * 60 * 5; // 5mins

export const useFetchUploadedCSVCount = ({ search, userId }) => {
  return useQuery(
    ['uploadedCSVCount', { search, userId }],
    () => countUploadedCSV({ search, userId }),
    {
      initialData: 0,
      keepPreviousData: true,
    },
  );
};

export const useFetchUploadedCSV = ({
  search,
  page,
  limit,
  userIds,
  templateIds,
  esps,
}) => {
  return useQuery(
    ['uploadedCSV', { search, page, limit, userIds, templateIds, esps }],
    () => getUploadedCSV({ search, page, limit, userIds, templateIds, esps }),
    {
      refetchInterval: latestData => {
        if (
          latestData?.data?.some(
            v =>
              v?.status === 'processing' ||
              v?.status === 'scheduled' ||
              v?.status === 'uploaded',
          )
        ) {
          return CSV_INFO_REFRESH_INTERVAL;
        }
        return CSV_INFO_REFRESH_INTERVAL_LONG;
      },
    },
  );
};

export const useFetchCSVMetrics = id => {
  return useQuery(['uploadedCSVMetrics', { id }], () => getCSVMetrics(id), {
    initialData: {},
    refetchInterval: CSV_METRICS_REFRESH_INTERVAL,
    refetchOnMount: 'always',
  });
};
